module.exports = __webpack_public_path__ + "static/media/SearchIcon.964f48e4.svg";